export default __webpack_public_path__ + "static/media/Unpublished_Icon.16679efb.svg";